<template>
  <div class="page-tenant">
    <img class="page-tenant-bg" src="../../images/login_back.png" />
    <div v-if="user.user" style="z-index: 9;position: relative;padding-top: 200px;">
      <div style="font-size:32px; color: #fff;text-align: center;margin-bottom: 40px;">我的医院</div>
      <div class="tenant-wrap" style="width: calc(100vw - 100px)">
        <div class="tenant el-card is-always-shadow" v-for="t in user.user.tenants" :key="t.id" @click="handleClick(t)">
          <img v-if="t.avatar" :src="t.avatar" class="image">
          <div class="tenant">
            <div style="font-size: 16px;font-weight: 500;margin-bottom: 6px">{{t.remake}}</div>
            <div v-if="t.tag">{{t.tag}}</div>
            <div v-if="t.address" style="width: 100%;text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{t.address}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import storage from 'store';
import { mapGetters } from 'vuex'
import { fetchAddressBookListApi } from '../../utils/addressBook'
import { getImTokenApi } from "../../api/common"
import { TENANT, IM_TOKEN } from "../../utils/env"
import { setDocumentTitle } from "../../utils/domUtil"
import { Message } from "iview"
export default {
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    handleClick(t) {
      this.temp_loading = Message.loading({
        content: '数据加载中',
        duration: 0
      });
      this.$store.commit('setTenant', t);
      storage.set(TENANT + this.$store.state.user.user.id, t, 7 * 24 * 60 * 60 * 1000);
      setDocumentTitle(t.remake);
      fetchAddressBookListApi();
      getImTokenApi().then(res => {
        if (res.code === 0) {
          this.$store.commit('setIm', res.data);
        } else {
          this.$Message.error('获取im接口服务异常!!!');
        }
      });
      this.$store.dispatch('getShiftListV2').then(
        () => {
          this.$router.replace({ name: 'base' })
        },
        (res) => {
          this.$Message.error(res.message);
          this.$store.dispatch("Logout").finally(() => {
            this.$router.replace({
              path: '/user/login',
              query: { redirect: this.$route.fullPath },
            })
          })
        }
      ).finally(() => {
        this.temp_loading();
      })
    }
  }
}
</script>
<style lang="less">
.page-tenant {
  position: relative;
  &-bg{
    position: absolute;
    top: -10%;
    left: 0;
    width: 100%;
    z-index: 0;
    transform: scale(1, 0.9);
  }
  .image{
    width: 80px;
    height: 80px;
    display: block;
  }
  .tenant-wrap{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    cursor: pointer;
    margin: 0 auto;
    padding-bottom: 50px;
  }
  .tenant{
    width: 300px;
    height: 205px;
    margin: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
